export const isUploadAnywhere = state => state.upload.get('isUploadAnywhere');

export function isUploading(state) {
  return state.upload.get('uploading');
}

export function getError(state) {
  return state.upload.get('error');
}

export function getIconId(state) {
  return state.upload.get('iconId');
}

export function getViewId(state) {
  return state.upload.get('viewId');
}

export function isSuccessful(state) {
  return state.upload.get('successful');
}

export function getUrl(state) {
  return state.upload.get('url');
}

export function getUploadIconData(state) {
  const excludedKeys = ['error', 'successful', 'uploading'];
  return state.upload
    .filterNot((val, key) => excludedKeys.includes(key))
    .toObject();
}
